/**
 * Created by andrey on 20.11.17.
 */

cc.checkGLErrorDebug = function (glProgram, event) {
    if (cc._renderType === cc.game.RENDER_TYPE_WEBGL) {
        let error = cc._renderContext.getError();

        if (!error && event === "afterCreateProgramObj" && !(glProgram._programObj instanceof WebGLProgram)) {
            error = "notWebGLProgram";
        }

        if (!error) {
            return;
        }

        const messages = [
            `error: ${error}`
        ];

        if (glProgram) {
            messages.push(`glProgram._programObj isUndefined: ${typeof glProgram._programObj === "undefined"}`);
            messages.push(`glProgram._programObj is WebGLProgram: ${glProgram._programObj instanceof WebGLProgram}`);
        }

        if (connector.info.isNative && connector.info.os === cc.sys.OS_ANDROID) {
            messages.push(`info: ${JSON.stringify(cleverapps.info && cleverapps.info.data)}`);
        }

        const message = `WebGL error: ${messages.join(" - ")}`;

        if (cleverapps.Shaders.initializing) {
            console.log(message);
        } else {
            cleverapps.throwAsync(message);
        }
    }
};

cc.Base = cc.Node;

cc.Base.prototype.replaceParent = function (newParent) {
    this.removeTemporarily(false);
    newParent.addChild(this);
};

cc.Base.GetHierarchyRotation = function (target) {
    const rotation = { x: 0, y: 0 };
    while (target) {
        rotation.x += target.getRotationX();
        rotation.y += target.getRotationY();
        target = target.parent;
    }
    return rotation;
};

cc.Base.AdjustRotationTo = function (start, target) {
    const rotation = cc.Base.GetHierarchyRotation(target);
    rotation.x *= -1;
    rotation.y *= -1;

    let node = start;
    while (node) {
        rotation.x += node.getRotationX();
        rotation.y += node.getRotationY();
        node = node.parent;
    }
    return rotation;
};

cc.Base.GetHierarchyScale = function (target) {
    const scale = { x: 1, y: 1 };
    while (target) {
        scale.x *= target.scaleX;
        scale.y *= target.scaleY;
        target = target.parent;
    }
    return scale;
};

cc.Base.AdjustScaleTo = function (start, target) {
    const scale = cc.Base.GetHierarchyScale(start);
    const targetScale = cc.Base.GetHierarchyScale(target);

    scale.x /= targetScale.x;
    scale.y /= targetScale.y;

    return scale;
};

cc.Base.prototype.replaceParentSamePlace = function (newParent, options) {
    if (options && options.keepScale) {
        const scale = cc.Base.AdjustScaleTo(this, newParent);
        this.setScaleX(scale.x);
        this.setScaleY(scale.y);
    }
    if (options && options.keepRotation) {
        const rotation = cc.Base.AdjustRotationTo(this, newParent);
        this.setRotationX(rotation.x);
        this.setRotationY(rotation.y);
    }
    const pos = newParent.convertToNodeSpace(this.parent.convertToWorldSpace(this.getPosition()));
    this.replaceParent(newParent);
    this.setPosition(pos);
};

cc.Base.GetTargetPosition = function (start, target) {
    return start.parent.convertToNodeSpace(target.parent.convertToWorldSpace(target.getPosition()));
};

cc.Base.prototype.createListener = function (listener) {
    let self = this;
    addCleaner(this, () => {
        self = undefined;
        listener = undefined;
    });
    return function (...args) {
        if (listener && self && !self.stopListeners) {
            return listener.call(self, ...args);
        }
    };
};

cc.Base.prototype.hasTouch = function (touch) {
    if (!this.visible) {
        return false;
    }
    const point = this.convertTouchToNodeSpace(touch);
    return cc.rectContainsPoint(cc.rect(0, 0, this.width, this.height), point);
};

cc.Base.prototype.createListener_onExitTransitionDidStart = cc.Base.prototype.onExitTransitionDidStart;
cc.Base.prototype.onExitTransitionDidStart = function () {
    this.stopListeners = true;
    delete this.preferredBundles;

    this.createListener_onExitTransitionDidStart();

    if (this.avoidNode || this.updateDynamicPosition) {
        const scene = cleverapps.Scenes.GetRunningScene();

        if (this.avoidNode && scene.sceneComponent) {
            scene.sceneComponent.removeAvoidNode(this);
        }

        if (this.updateDynamicPosition && scene.sceneComponent) {
            scene.sceneComponent.removeDynamicNode(this);
        }
    }
};

cc.Base.prototype.onEnterTransitionDidFinish = cleverapps.extendFunc(cc.Base.prototype.onEnterTransitionDidFinish, function (...args) {
    this.stopListeners = false;
    delete this.preferredBundles;

    this._super.call(this, ...args);

    if (this.avoidNode || this.updateDynamicPosition) {
        const scene = cleverapps.Scenes.GetRunningScene();

        if (this.avoidNode && scene.sceneComponent) {
            scene.sceneComponent.addAvoidNode(this);
        }

        if (this.updateDynamicPosition && scene.sceneComponent) {
            scene.sceneComponent.addDynamicNode(this);
        }
    }
});

cc.Base.prototype.cleanup = cleverapps.extendFunc(cc.Base.prototype.cleanup, function () {
    this.stopListeners = true;
    runCleaners(this);
    this._super();
});

cc.Base.prototype.runAction = cleverapps.extendFunc(cc.Base.prototype.runAction, function (...args) {
    if (this.stopListeners && cleverapps.config.debugMode) {
        cleverapps.throwAsync("runAction on stopped node");
    }

    if (this.saveStack) {
        this.actionStack = new Error().stack;
    }

    return this._super.call(this, ...args);
});

cc.Base.prototype.addCleaner = function (callback) {
    addCleaner(this, callback);
};

cc.Base.prototype.addChild = cleverapps.extendFunc(cc.Base.prototype.addChild, function (node, ...args) {
    this._super.call(this, node, ...args);

    cleverapps.inputDispatcher.markHandlersDirty();

    ComponentMap.callHooks(node, "onParented");
});

cc.Base.prototype.positionFromAlignment = function (x, y, options) {
    if (Array.isArray(x)) {
        x = x[cleverapps.resolution.mode];
    }

    if (options === undefined) {
        options = typeof x === "object" ? (x.options || x) : {};
    }

    if (y === undefined) {
        y = x.y;
        x = x.x;
    }

    if (typeof x === "object" || typeof y === "object") {
        let parentSize;
        const box = options.box;
        if (this.parent) {
            parentSize = this.parent.getContentSize();
        }

        if (box) {
            parentSize = box;
        }
        if (options.parentSize) {
            parentSize = options.parentSize;
        }

        if (!parentSize) {
            return { x, y, options };
        }

        if (typeof x === "object") {
            x = this.calculateAxis(x, "x", parentSize.width) + (box && box.x || 0);
        }

        if (typeof y === "object") {
            y = this.calculateAxis(y, "y", parentSize.height) + (box && box.y || 0);
        }
    }

    return cc.p(Math.floor(x), Math.floor(y));
};

cc.Base.prototype.setAlignment = function (x, y, options) {
    const alignment = y === undefined ? x : { x, y, options };

    const alignmentComponent = ComponentMap.get(this, AlignmentComponent);
    if (alignmentComponent) {
        alignmentComponent.setAlignment(alignment);
    } else {
        ComponentMap.attach(this, new AlignmentComponent({ alignment }));
    }
};

cc.Base.prototype.doAlignment = function () {
    const alignmentComp = ComponentMap.get(this, AlignmentComponent);
    if (alignmentComp) {
        alignmentComp.apply();
    }
};

cc.Base.prototype.setPosition = cleverapps.extendFunc(cc.Base.prototype.setPosition, function (x, y) {
    this._super(x, y);

    if (isNaN(this.x) || isNaN(this.y)) {
        if (cleverapps.config.debugMode) {
            throw `In setPosition value is NaN or undefined: x = ${this.x}, y = ${this.y}`;
        }
        cleverapps.throwAsync(`In setPosition value is NaN or undefined: x = ${this.x}, y = ${this.y}`);
    }
});

cc.Base.prototype.calculateAxis = function (styles, axis, parentSize) {
    let c = styles[`d${axis}`] || 0;

    const anchorPoint = axis === "x" ? this.getAnchorPoint().x : this.getAnchorPoint().y;
    let dimension = axis === "x" ? this.width * Math.abs(this.scaleX) : this.height * Math.abs(this.scaleY);
    if (styles.anchor === false) {
        dimension = 0;
    } else if (styles.anchor !== undefined) {
        if (axis === "x") {
            this.setAnchorPoint(styles.anchor, this.anchorY);
        } else {
            this.setAnchorPoint(this.anchorX, styles.anchor);
        }
    }

    const align = styles.align || "center";
    switch (align) {
        case "left":
        case "bottom":
            c += anchorPoint * dimension;
            break;
        case "center":
            c += parentSize / 2;
            c += (anchorPoint - 1 / 2) * dimension;
            break;
        case "right":
        case "top":
            c += parentSize;
            c += (anchorPoint - 1) * dimension;
            break;
    }

    return c;
};

cc.Base.prototype.getRelativeCoordinates = function (target) {
    return this.getParent().convertToNodeSpace(target.getParent().convertToWorldSpace(target.getPosition()));
};

cc.Node.prototype.getScale = function () {
    if (this.scaleX !== this.scaleY) {
        cleverapps.throwAsync(`getScale with different scaleX=${this.scaleX} and scaleY=${this.scaleY}`);
    }
    return this.scaleX;
};

cc.Base.prototype.setContentSize2 = function (width, height) {
    if (Array.isArray(width)) {
        width = width[cleverapps.resolution.mode];
    }

    if (Array.isArray(height)) {
        height = height[cleverapps.resolution.mode];
    }

    if (height === undefined) {
        height = width.height;
        width = width.width;
    }

    this.setContentSize(width, height);
};

cc.Base.prototype.setContentSize = cleverapps.extendFunc(cc.Base.prototype.setContentSize, function (size, height) {
    const oldWidth = this.width;
    const oldHeight = this.height;

    this._super(size, height);

    if (oldWidth !== this.width || oldHeight !== this.height) {
        this.children.forEach((child) => {
            ComponentMap.callHooks(child, "onParentSizeChanged");
        });
    }
});

cc.Base.prototype.setScale2 = function (scale) {
    if (Array.isArray(scale)) {
        scale = scale[cleverapps.resolution.mode];
    }

    this.setScale(scale);
};

cc.Base.prototype.getBoundingBox = function () {
    const scaleX = this.scaleX;
    const scaleY = this.scaleY;
    const baseScaleX = this.baseScaleX || this.baseScale || scaleX;
    const baseScaleY = this.baseScaleY || this.baseScale || scaleY;
    const change = scaleX !== baseScaleX || scaleY !== baseScaleY;

    if (change) {
        this.setScale(baseScaleX, baseScaleY);
    }

    const rect = cc.rect(0, 0, this._contentSize.width, this._contentSize.height);
    const box = cc.rectApplyAffineTransform(rect, this.getNodeToParentTransform());

    if (change) {
        this.setScale(scaleX, scaleY);
    }

    return box;
};

cc.Base.prototype.getNodeToSceneTransform = function () {
    let t = this.getNodeToParentTransform();
    for (let p = this.parent; p !== null; p = p.parent) {
        if (ComponentMap.get(p, SceneComponent)) {
            return t;
        }
        t = cc.affineTransformConcat(t, p.getNodeToParentTransform());
    }
};

cc.Base.prototype.getSceneBoundingBox = function () {
    const rect = cc.rect(0, 0, this._contentSize.width, this._contentSize.height);
    const trans = this.getNodeToSceneTransform();
    return cc.rectApplyAffineTransform(rect, trans);
};

cc.Base.prototype.getGlobalBoundingBox = function () {
    const rect = cc.rect(0, 0, this._contentSize.width, this._contentSize.height);
    const trans = this.getNodeToWorldTransform();
    return cc.rectApplyAffineTransform(rect, trans);
};

cc.Base.prototype.setCascadeOpacityEnabledRecursively = function () {
    cc.Base.PerformRecursive(this, (node) => {
        node.setCascadeOpacityEnabled(true);
    });
};

cc.Base.prototype.setRecCascadeColorEnabled = function () {
    cc.Base.PerformRecursive(this, (node) => {
        node.setCascadeColorEnabled(true);
    });
};

cc.Base.PerformRecursive = function (node, callback) {
    const q = [node];
    while (q.length > 0) {
        const t = q.pop();
        callback(t);
        q.push(...t.children);
    }
};

cc.Base.PerformRecursiveFromLeaves = function (node, callback, filter) {
    const q = [node];
    const e = [false];

    while (q.length > 0) {
        const t = q.pop();
        const expanded = e.pop();

        if (expanded) {
            callback(t);
            continue;
        }

        if (filter && !filter(t)) {
            continue;
        }

        q.push(t);
        e.push(true);

        const children = t.children;
        for (let i = children.length - 1; i >= 0; i--) {
            q.push(children[i]);
            e.push(false);
        }
    }
};

cc.Base.prototype.getPreferredBundles = function () {
    if (this.preferredBundles !== undefined) {
        return this.preferredBundles;
    }

    this.preferredBundles = false;

    if (this.bundles) {
        this.preferredBundles = this.bundles.filter((name) => !["dev_resources"].includes(name)).reduce((result, name) => {
            const bundle = bundles[name];
            return result.concat(bundle.injectTo || [name]);
        }, []); 
    } else if (this.parent) {
        this.preferredBundles = this.parent.getPreferredBundles();
    }

    return this.preferredBundles;
};

cc.Base.prototype.getCropContainer = function () {

};

cc.Base.prototype.convertTouchToNodeSpaceDisplacement = function (touch) {
    let startPosition = this.convertToNodeSpace(touch.getStartLocation());
    let currentPosition = this.convertToNodeSpace(touch.getLocation());

    const angleRadians = -(Math.PI / 180) * this.getRotation();

    const mapPosition = function (pos) {
        return {
            x: pos.x * Math.cos(angleRadians) - pos.y * Math.sin(angleRadians),
            y: pos.x * Math.sin(angleRadians) + pos.y * Math.cos(angleRadians)
        };
    };

    startPosition = mapPosition(startPosition);
    currentPosition = mapPosition(currentPosition);

    return cc.p(currentPosition.x - startPosition.x, currentPosition.y - startPosition.y);
};

cc.Base.prototype.removeTemporarily = function (...args) {
    if (engine === "creator") {
        this._temporarilyRemoved = true;
    }

    this.removeFromParent.call(this, ...args);
};

cc.Base.CHILDREN_ORDER_FN = function (child1, child2) {
    return (child1._localZOrder - child2._localZOrder) || (child1.arrivalOrder - child2.arrivalOrder);
};

cc.Scene.prototype.ctor = cleverapps.extendFunc(cc.Scene.prototype.ctor, function () {
    cleverapps.eventManager.setCurrentFeatures();
    cleverapps.skins.update();

    this._super();
});

cc.Base.prototype.setLocalZOrder = cleverapps.extendFunc(cc.Base.prototype.setLocalZOrder, function (...args) {
    this._super.call(this, ...args);

    cleverapps.inputDispatcher.markHandlersDirty();
});